import "./css/main.scss";
import Homepage from './components/Homepage'
const App: React.FC = () => {
  return (
    <div className="App">
      <Homepage />
    </div>
  );
};

export default App;
